<template>
  <div class="tenant-custom-list">
    <div v-if="loading" class="center fh loader custom-list-loader-backdrop">
      <loading-circle />
    </div>
    <div class="custom-list-data">
      <div class="custom-list-data-container">
        <list-items
          :list="customLists"
          :selected="selectedList"
          :loadingMore="loadingMore"
          @update="refreshCustomLists"
          @select="getListDetails"
          @fetch-data="fetchData"
          @load-more="loadMoreCustomLists"
        />
        <div class="custom-list-detail-pane">
          <copy-list-detail
          :selected="selectedList"
          :custom-lists="customLists"
          @update="handleListDataUpdate"/>
        </div>
        <!-- <div v-else>
        <list-detail
          :selected="selectedList"
          @update="getListDetails"
        />
      </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationDialog from '@/plugins/confirmationDialog'
import LoadingCircle from '@/components/common/loadingCircle.vue'
import { success, alert } from '@/plugins/notification'
import Loader from '@/plugins/loader'
import { GetPaginatedActiveCustomLists, DeleteCustomList } from '@/api'
import ListItems from '../../components/settings/customLists/listItems.vue'
// import ListDetail from '../../components/settings/customLists/listDetail.vue'
import copyListDetail from '@/components/settings/customLists/copyListDetail.vue'
export default {
  components: {
    LoadingCircle,
    ListItems,
    // ListDetail,
    copyListDetail
  },
  data () {
    return {
      loading: false,
      loadingMore: false,
      hasMore: true,
      limit: 20,
      offset: 0,
      currentWhere: {},
      currentOrderBy: [{ updated_on: 'desc' }],
      customLists: [],
      selectedList: {
        id: null,
        index: null,
        loading: false,
        data: null,
        system_generated: false
      }
    }
  },
  computed: {
    isCopyList () {
      return (
        this.$route.fullPath.includes('copy-custom-list')
      )
    }
  },
  methods: {
    syncSelectedFromRoute () {
      const routeId = this.$route.params.id
      if (!routeId) {
        this.selectedList.id = null
        this.selectedList.index = null
        this.selectedList.data = null
        this.selectedList.system_generated = false
        return
      }

      const index = this.customLists.findIndex(item => String(item.id) === String(routeId))
      if (index === -1) {
        this.selectedList.id = null
        this.selectedList.index = null
        this.selectedList.data = null
        this.selectedList.system_generated = false
        return
      }

      const selected = this.customLists[index]
      if (String(this.selectedList.id) === String(selected.id) && this.selectedList.data) {
        this.selectedList.index = index
        return
      }

      this.getListDetails({ id: selected.id, index }, { syncRoute: false })
    },
    fetchData ({ where, orderBy }) {
      this.currentWhere = where || {}
      if (orderBy && orderBy.length) {
        this.currentOrderBy = orderBy
      }
      this.getCustomList()
    },
    getCustomList ({ silent = false } = {}) {
      if (!silent) {
        this.loading = true
      }

      this.offset = 0
      this.hasMore = true

      GetPaginatedActiveCustomLists(this.limit, this.offset, this.currentWhere, this.currentOrderBy)
        .then((res) => {
          this.customLists = res.core_custom_list
          if (res.core_custom_list.length < this.limit) {
            this.hasMore = false
          }
          this.syncSelectedFromRoute()
        })
        .finally(() => {
          if (!silent) {
            this.loading = false
          }
        })
    },
    loadMoreCustomLists () {
      if (!this.hasMore || this.loadingMore || this.loading) return

      this.loadingMore = true
      this.offset += this.limit

      GetPaginatedActiveCustomLists(this.limit, this.offset, this.currentWhere, this.currentOrderBy)
        .then((res) => {
          if (res.core_custom_list.length > 0) {
            this.customLists = [...this.customLists, ...res.core_custom_list]
          }
          if (res.core_custom_list.length < this.limit) {
            this.hasMore = false
          }
        })
        .finally(() => {
          this.loadingMore = false
        })
    },
    refreshCustomLists () {
      this.getCustomList({ silent: true })
    },
    getListDetails ({ id, index }, { syncRoute = true } = {}) {
      if (!id) {
        this.selectedList.id = null
        this.selectedList.index = null
        this.selectedList.data = null
        this.selectedList.system_generated = false
        if (syncRoute && this.$route.params.id) {
          this.$router.replace('/settings/custom-list')
        }
        return
      }

      if (syncRoute && String(this.$route.params.id) !== String(id)) {
        this.$router.replace(`/settings/custom-list/${id}`)
      }

      this.selectedList.id = id
      this.selectedList.index = index ?? null

      const resolvedIndex = index ?? this.customLists.findIndex(item => String(item.id) === String(id))
      const selectedItem = this.customLists[resolvedIndex] || null

      if (resolvedIndex !== -1) {
        this.selectedList.index = resolvedIndex
      }

      this.selectedList.system_generated = Boolean(selectedItem?.system_generated ?? false)
      this.selectedList.data = selectedItem ? { name: selectedItem.name, system_generated: selectedItem.system_generated } : null
    },
    async handleListDataUpdate ({ id, index } = {}) {
      await this.refreshCustomLists()
      this.getListDetails({ id: id ?? this.selectedList.id, index: index ?? this.selectedList.index })
    },
    handleListCreated () {
      this.getCustomList()
    },
    handleListEdited () {
      this.getCustomList()
    },
    deleteSelectedList () {
      ConfirmationDialog(
        `Are you sure you want to delete the list titled ${
          this.customLists[this.selectedList.index].name
        }`,
        (res) => {
          if (res) {
            const loader = new Loader()
            loader.show()
            DeleteCustomList(this.customLists[this.selectedList.index].id)
              .then((res) => {
                success('Deleted the selected list')
                this.customLists.splice(this.selectedList.index, 1)
                this.selectedListDetails = null
                this.selectedList.id = null
                this.selectedList.index = null
              })
              .catch((err) => {
                alert(err[0]?.message ?? 'Something went wrong')
              })
              .finally(() => {
                loader.hide()
              })
          }
        }
      )
    }
  },
  watch: {
    '$route.params.id' () {
      if (this.loading) return
      this.syncSelectedFromRoute()
    }
  },
  mounted () {
    this.getCustomList()
  }
}
</script>

<style scoped lang="scss">
.tenant-custom-list {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.custom-list-data {
  height: 100%;
  overflow: hidden;
  &-container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 2.5fr;
    grid-gap: 10px;
    min-height: 0;
    overflow: hidden;
  }
}
.custom-list-detail-pane {
  background: #fff;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
.custom-list-loader-backdrop {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
}
</style>
